import { createRouter, createWebHistory } from 'vue-router'

import home from "@/containers/home.vue";
import bolsasdeestudo from "@/containers/bolsasdeestudo.vue";
import bolsasdeestudodetalhe from "@/containers/bolsadeestudodetalhe.vue";
import alimentacao from "@/containers/alimentacao.vue";
import alojamento from "@/containers/alojamento.vue";
import avisosecomunicados from "@/containers/avisosecomunicados.vue";
import noticiassas from "@/containers/noticiassas.vue";
import documentacao from "@/containers/documentacao.vue";
import aviso from "@/containers/aviso.vue";
import equipa from "@/containers/equipa.vue";
import noticia from "@/containers/noticia.vue";
import form from "@/containers/alojamento/form.vue";

let baseUrl = window.currentLanguage == "en" ?
    import.meta.env.VITE_APP_BASEURLEN : 
    import.meta.env.VITE_APP_BASEURL;

const router = createRouter({
  history: createWebHistory(baseUrl),
  routes: [
    { path: '/', name: 'home', component: home },
    { path: '/bolsasdeestudo/:id', name: 'bolsadeestudo', component: bolsasdeestudodetalhe },
    { path: '/bolsasdeestudo', name: 'bolsasdeestudo', component: bolsasdeestudo },
    { path: '/alimentacao', name: 'alimentacao', component: alimentacao },
    { path: '/alojamento', name: 'alojamento', component: alojamento },
    { path: '/avisosecomunicados/:id', name: 'avisoecomunicado', component: aviso },
    { path: '/avisosecomunicados', name: 'avisosecomunicados', component: avisosecomunicados },
    { path: '/noticiassas/:id', name: 'noticiasas', component: noticia },
    { path: '/noticiassas', name: 'noticiassas', component: noticiassas },
    { path: '/documentacao', name: 'documentacao', component: documentacao },
    { path: '/equipa', name:"equipa", component: equipa },
    { path: '/formulario', component: form, name: 'alojamentoForm', props: true },
    //{ path: '*', redirect : '/'}
  ],
  scrollBehavior (to, from, savedPosition) {
    if(to.name == "home" && from.name == "equipa"){
      return {
        el: "#linksbar",
        top: 30
      }
    }
    return { top: 0 }
  }
})

export default router
